import { useSelector } from "react-redux";

import { can, hasAnyPermission, hasAllPermissions } from "../utils/permissions";

export default function usePermissions() {
  const { user } = useSelector((state) => state.auth);

  const permissions = user?.permissions || [];

  return {
    permissions,

    can: (permission) => can(permissions, permission),

    hasAnyPermission: (requiredPermissions) =>
      hasAnyPermission(permissions, requiredPermissions),

    hasAllPermissions: (requiredPermissions) =>
      hasAllPermissions(permissions, requiredPermissions),
  };
}
